export const regExps = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  katakana: /^[\u30A0-\u30FF]+$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!"#$%&@'()*+,-./_]*$/,
  phone: /^0(\d-\d{4}|\d{2}-\d{3,4}|\d{3}-\d{2}|\d{4}-\d)-\d{4}$/,
  zipCode: /^[0-9]{7}$/,
};
